import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";
import { get, post } from "../../redux/api/ApiHandler";

const NextMove = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const [popup, setPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [departList, setDepartList] = useState("");
  const [head, setHead] = useState("");
  // const [regionOptions, setRegionOptions] = useState([]);

  const team = location?.state?.team;
  const id = location?.state?.id;
  const status = location?.state?.status;

  const customer_id = location?.state?.customerId;
  const region_id = location?.state?.regionId;
  const servEng_id = location?.state?.servEngId;
  const regMan_id = location?.state?.regManId;
  const cusPrinterId = location?.state?.cusPrinterId;


  const regionOptions = [
    // { value: 3, label: "Technical" },
    // { value: 2, label: "Inventory" },
    { value: 5, label: "Service Engineer" },
  ]




  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      regionname: "",
      location: "",
    },
  });


  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#D9D9D9",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };


  const handlePopup = () => {
    let values = getValues();
    if (!description) {
      toast.error("Enter Description");
      return;
    }
    if (!values?.location?.value) {
      toast.error("Enter Department");
      return;
    }

    setPopup(true);
  }



  const closeTicket = async () => {
    let values = getValues();

    let assi_id = values?.location?.value;

    let payload = {
      assigned_id: values?.location?.value,
      assigned_for: head == 3 ? 2 : head == 2 ? 3 : head == 5 ? 1 : "",
      remarks: description,
      current_status: 8,
      region_id: region_id,
      regional_manager_id: regMan_id,
      service_engineer_id: servEng_id,
      customer_id: customer_id,
      customer_printer_id: cusPrinterId,
      support_needed: 3,
      status: 2,
    }
    // console.log(":payload", payload);
    // return;

    let res = await post(URLS.TICKET_CLOSE + id, payload)
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup(false);
      navigate("/next-visit");

    }
  }


  const inventoryList = async (event) => {
    let values = getValues();

    let payload = {
      role: event?.value,
      region_id: event?.value == 5 ? region_id : null,
    }



    const res = await post(URLS.DEPARTMENT_LIST, payload);
    if (res?.status == "success") {
      const options = res?.data?.map((item) => ({
        value: item?.id,
        label: item?.name,

      }))
      console.log("ssssss", options);

      setDepartList(options);
    }
  }



  // useEffect(() => {
  //   inventoryList()
  // }, []);



  const handleChange = (event, field) => {
    field.onChange(event)
    inventoryList(event)
    setHead(event?.value)
  }




  return (
    <div>
      <Topbar header="Next Visit" subHead="Edit / Move" />

      <div className="container_fluit1 px-4 py-3">
        <label className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-19 fs-xxl-20 mb-3 mt-3">
          Regional Ticket ID :{" "}
          <span className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-19 fs-xxl-20">
            N3465
          </span>
        </label>

        <form
          className="d-flex flex-wrap gap-5"
        // onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-md-5">
            <Controller
              control={control}
              name="regionname"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Choose the Team
                  </label>
                  <Select
                    {...field}
                    options={regionOptions}
                    placeholder="Select Team"
                    isSearchable
                    onChange={(event) => handleChange(event, field)}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.regionname && (
                    <p style={{ color: "red" }}>{errors.regionname.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="location"
              rules={{ required: "Location is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    {head == 3 ? "Technical" : head == 2 ? "Inventory" : head == 5 ? "Service Engineer" : ""} Department
                  </label>
                  <Select
                    {...field}
                    options={departList}
                    placeholder="Select "
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.location && (
                    <p style={{ color: "red" }}>{errors.location.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* <div className="col-md-5">
            <Controller
              control={control}
              name="regionname"
              rules={{ required: "Team is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Choose the Team
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Team"
                    disabled
                  />
                  {errors.regionname && (
                    <p style={{ color: "red" }}>{errors.regionname.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="location"
              rules={{ required: "Department is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    {status == 5 ? "Technical" : status == 3 ? "Inventory" : status == 7 ? " Next Visit" : status == 9 ? "Senior Support" : "-"} Department
                  </label>
                  <Select
                    {...field}
                    options={regionOptions}
                    placeholder="Select Department"
                    isSearchable
                    onChange={field.onChange}
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                  {errors.location && (
                    <p style={{ color: "red" }}>{errors.location.message}</p>
                  )}
                </div>
              )}
            />
          </div> */}
          <div className="col-md-11 mt-3">
            <Controller
              control={control}
              name="issue"
              rules={{ required: "Role is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Issue Description By Super Admin <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={description} onChange={(e) => setDescription(e.target.value)}
                    className="input-box"
                    placeholder="Enter Role"
                    disabled={isViewMode}
                  />
                  {errors.issue && (
                    <p style={{ color: "red" }}>{errors.issue.message}</p>
                  )}
                </div>
              )}
            />
          </div >
        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 button_submit ac-jb my-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>

          <button
            type="submit"
            onClick={() => handlePopup()}
            className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            Assign
          </button>
        </div>
        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 mt-4 mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
                Are you sure you want to assign?
              </p>
              <div className="d-flex ac-jb px-2 mt-5">
                <button
                  onClick={() => setPopup(false)}
                  className="no-btn f2 w-40"
                >
                  No
                </button>
                <button onClick={() => closeTicket()} className="yes-btn f2 w-40">
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}


      </div>
    </div>
  );
};

export default NextMove;
